/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutoDecisioningSummary } from './AutoDecisioningSummary';
import {
    AutoDecisioningSummaryFromJSON,
    AutoDecisioningSummaryFromJSONTyped,
    AutoDecisioningSummaryToJSON,
    AutoDecisioningSummaryToJSONTyped,
} from './AutoDecisioningSummary';

/**
 * 
 * @export
 * @interface GetAutoDecisioningSummary200Response
 */
export interface GetAutoDecisioningSummary200Response {
    /**
     * 
     */
    data?: AutoDecisioningSummary;
}

/**
 * Check if a given object implements the GetAutoDecisioningSummary200Response interface.
 */
export function instanceOfGetAutoDecisioningSummary200Response(value: object): value is GetAutoDecisioningSummary200Response {
    return true;
}

export function GetAutoDecisioningSummary200ResponseFromJSON(json: any): GetAutoDecisioningSummary200Response {
    return GetAutoDecisioningSummary200ResponseFromJSONTyped(json, false);
}

export function GetAutoDecisioningSummary200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoDecisioningSummary200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : AutoDecisioningSummaryFromJSON(json['data']),
    };
}

export function GetAutoDecisioningSummary200ResponseToJSON(json: any): GetAutoDecisioningSummary200Response {
    return GetAutoDecisioningSummary200ResponseToJSONTyped(json, false);
}

export function GetAutoDecisioningSummary200ResponseToJSONTyped(value?: GetAutoDecisioningSummary200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AutoDecisioningSummaryToJSON(value['data']),
    };
}

